/* eslint-disable react/prop-types */
import {useContext, useState} from 'react'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import AtomImage, {LOADING} from '@s-ui/react-atom-image'
import AtomSkeleton from '@s-ui/react-atom-skeleton'
import Context from '@s-ui/react-context'
import MoleculeAccordion, {moleculeAccordionBehavior, MoleculeAccordionItem} from '@s-ui/react-molecule-accordion'
import IconArrowUp from '@adv-mt/mt-svg-icons/lib/AngleUp.js'
import IconChevronDown from '@adv-mt/mt-svg-icons/lib/ChevronDown.js'

import {defaultStateOpenTermsTabs, termsAndConditions} from '../utils/config.js'
import TermsContent from './terms-content.js'

const ReservationTerms = () => {
  const {i18n, domain} = useContext(Context)
  const config = domain.get('config')
  const URL_STATICS_IMAGES = config.get('URL_STATICS_IMAGES')
  const [openTermsTabs, setOpenTermsTabs] = useState(defaultStateOpenTermsTabs)

  return (
    <>
      <div className="mt-DrawerReservationInitialization-terms">
        <div className="mt-DrawerReservationInitialization-termsImage">
          <AtomImage
            src={`${URL_STATICS_IMAGES}coches/transaction/reservasIMG_1@2x.png`}
            alt="Información sobre reservas"
            role="presentation"
            loading={LOADING.LAZY}
            spinner={<AtomSkeleton width="100%" height="200px" />}
          />
        </div>
        <MoleculeAccordion
          headerIconCollapsed={
            <div className="mt-DrawerReservationInitialization-headerIcon">
              <IconChevronDown size={ATOM_ICON_SIZES.medium} />
            </div>
          }
          headerIconExpanded={
            <div className="mt-DrawerReservationInitialization-headerIcon">
              <IconArrowUp size={ATOM_ICON_SIZES.medium} />
            </div>
          }
          behavior={moleculeAccordionBehavior.MULTIPLE}
          onChange={(ev, value) => {
            setOpenTermsTabs({...openTermsTabs, [value.value]: value.isExpanded})
          }}
        >
          {termsAndConditions.map(({id, title, content}, index) => (
            <MoleculeAccordionItem
              content={
                <div className="mt-DrawerReservationInitialization-accordionContent">
                  <TermsContent documentName={content} />
                </div>
              }
              headerAs="div"
              id={id}
              isExpanded={openTermsTabs[id]}
              label={<div className="mt-DrawerReservationInitialization-accordionHeader">{i18n.t(title)}</div>}
              value={id}
            />
          ))}
        </MoleculeAccordion>
      </div>
    </>
  )
}

ReservationTerms.displayName = 'ReservationTerms'

export {ReservationTerms}
